import { Map } from 'immutable';
import { IRecordOf, RecordOf } from '@opengov/compose-app/immutable';

import { ILocale, INamespaceState } from '../../types';

export const Namespace = RecordOf<INamespaceState>({
  loading: false,
  error: null,
  data: {}
});

export const Locale = RecordOf<ILocale>({
  locale: null,
  namespaces: Map<string, IRecordOf<INamespaceState>>()
});
